module.exports = __webpack_public_path__ + "static/img/eb-example-3.7c44c4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/eb-example-3.png
// module id = mXOk
// module chunks = 1